import {RequirementCompound} from "./requirementCompound";
import {ITest} from "./requirement";

export class RequirementAnd extends RequirementCompound {
    test(props: ITest): boolean {
        return this.requirements.every(requirement => requirement.test(props));
    }
}